interface BaseEntityType {
  readonly Id: number;
}

export function newValueForSelection<T extends BaseEntityType>(
  newOptions: readonly T[],
  oldValue: T | null): T | null {
  if (newOptions.length === 0)
    return null;
  if (newOptions.length === 1)
    return newOptions[0];
  if (oldValue === null)
    return null;
  const oldValueId = oldValue.Id;
  const newValue = newOptions.find(x => x.Id === oldValueId);
  if (newValue === undefined)
    return null;
  return newValue;
}

